import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import utils from './../../../utils/utilities';
import TableSelectBox from './../../../reusable/TableSelectBox/TableSelectBox.index.jsx';
import { ADD_RSS_LABELS_LIMIT_PER_ROW } from './../../../constants';
import { isEmpty } from 'lodash';

class ThirdPartiesCategories extends React.Component {

    constructor(props) {
        super(props);

        this.isCategorySelected = this.isCategorySelected.bind(this);
        this.toggleSelectAllCategories = this.toggleSelectAllCategories.bind(this);
        this.categoryCheckboxHandler = this.categoryCheckboxHandler.bind(this);
        this.selectAllCategories = this.selectAllCategories.bind(this);
        this.deSelectAllCategories = this.deSelectAllCategories.bind(this);

        this.categoriesSettingsLoaded = false;

        this.categoryRows = [];
        this.rowLabels = [];
        this.categoryOptions = [];
        this.rowNumber = 0;
    }

    componentDidMount() {
        this.props.actions.requestCategoryLabels();
    }

    componentWillReceiveProps(nextProps) {
        // After the selected categories have loaded from the server, it checks if all categories have been selected.
        if (!this.categoriesSettingsLoaded &&
            nextProps.state.selectedCategories.length > 0 &&
            !utils.isEmptyObject(nextProps.state.categoryNames)) {

            let allCategoriesLength = Object.keys(nextProps.state.categoryNames).length,
                selectedCategoriesLength = nextProps.state.selectedCategories.length;

            if (allCategoriesLength === selectedCategoriesLength) {
                this.toggleSelectAllCategories();
            }

            this.categoriesSettingsLoaded = true;

            const filteredSelectedCategories = nextProps.state.selectedCategories.filter(item => nextProps.state.categoryNames[item]);
            if (filteredSelectedCategories.length === 0) {
                this.deSelectAllCategories();
                this.props.resetSection('all-third-parties-section');
            }

        }
    }

    categoryCheckboxHandler(event) {

        let elem = event.target;

        if (elem.id && elem.id.indexOf('category-label-') === 0) {

            let input = elem.parentNode.getElementsByTagName('input')[0];

            if (input) {
                let categoryId = input.value,
                    itemIndex  = utils.inArray(categoryId, this.props.state.selectedCategories);

                //this.props.actions.clearValidationErrors(['api.error.feed.noRiskEntities']);
                this.props.actions.toggleCategory(categoryId, itemIndex);
            }
        }
    }

    toggleSelectAllCategories() {
        this.props.actions.toggleSelectAllCategories(!this.props.state.allCategoriesSelected);

    }

    selectAllCategories() {
        this.props.actions.toggleSelectAllCategories(true);
    }

    deSelectAllCategories () {
        this.props.actions.toggleSelectAllCategories(false);
    }

    isCategorySelected(categoryId) {
        return utils.inArray(categoryId, this.props.state.selectedCategories) > -1 ? true : false;
    }

    render() {

        let categoryNames = this.props.state.categoryNames;
        let categoryNamesLength = Object.keys(categoryNames).length;
        this.categoryRows = [];
        this.categoryOptions = [];
        let filteredSelectedCategories = [];
        if(!isEmpty(this.props.state.categoryNames)) {
            filteredSelectedCategories = this.props.state.selectedCategories.filter(item => this.props.state.categoryNames[item]);
        }

        if (categoryNamesLength > 0) {
            let i = 0;

            for (let categoryId in categoryNames) {
                if (categoryNames.hasOwnProperty(categoryId)) {

                    // Add the category labels
                    this.rowLabels.push(
                        <span className="category-name"
                              title={categoryNames[categoryId]}
                              key={'category-name-' + i}>

                            <input type="checkbox"
                                   id={'category-label-' + i}
                                   defaultValue={categoryId}
                                   defaultChecked={this.isCategorySelected(categoryId)} />

                            <label htmlFor={'category-label-' + i}
                                   className="checkbox-label">
                                {categoryNames[categoryId]}
                            </label>

                        </span>
                    );

                    // ...in the same time add the category options for the category filter dropdown
                    this.categoryOptions.push(
                        <option key={'category-option-' + i} value={categoryId}>
                            {categoryNames[categoryId]}
                        </option>
                    );

                    i++;

                    // Separate the category labels into rows of four
                    if (i % ADD_RSS_LABELS_LIMIT_PER_ROW === 0 || i === categoryNamesLength) {

                        this.categoryRows.push(
                            <div className="categories-section__body-row"
                                 key={'categories-section__body-row-' + this.rowNumber}>
                                {this.rowLabels}
                            </div>
                        );

                        this.rowNumber++;
                        this.rowLabels = [];

                    }

                }
            }

        } else {
            if (!this.props.state.loadingSpinner) {
                categoryNamesLength = 0;
                this.categoryRows.push(
                    <div className="no-categories" key="no-categories">
                        <FormattedMessage id="General_CoreFunctionality_UIText_general.nothingToDisplay" />
                    </div>
                );
            }
        }

        return (
            <div className="third-parties-sections categories-section">

                <div className={'add-rss-error no-categories-error' +
                                    this.props.setErrorClass(['api.error.feed.noRiskEntities'])}>
                    <FormattedMessage id="RSS_Add_Error_addRssFeed.thirdParties.noCategoriesError" />
                </div>

                <div className="categories-section__header">

                    <input type="checkbox"
                           value=""
                           id="rss-header-results"
                           checked={this.props.state.allCategoriesSelected}
                           onChange={this.toggleSelectAllCategories} />

                        <TableSelectBox
                            size={filteredSelectedCategories.length}
                            selectAllFunction={this.selectAllCategories}
                            deselectAllFunction={this.deSelectAllCategories}
                        />

                    <span className="divider"></span>

                    {
                        this.props.state.loadingSpinner ?
                            (
                                <span className="categories-section__header--counter">
                                            <div className="spinner js-categories-counter-spinner">
                                                <img src="assets/spinner.gif"
                                                     className="loading-spinner-image js-categories-counter-spinner"
                                                     alt="Loading categories counter" />
                                            </div>
                                        </span>
                            ) :
                            (
                                <span className="categories-section__header--counter">
                                            {categoryNamesLength}
                                    &nbsp;
                                    <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.results" />
                                        </span>
                            )
                    }


                    <div className="categories-section__header--search">

                        <input type="search"
                               className="notranslate search-input"
                               placeholder={this.props.intl.formatMessage({id: 'General_CoreFunctionality_UIText_general.search'})} />

                        <span className="search-icon la-Search" />

                    </div>

                </div>

                <div className="categories-section__body" onClick={this.categoryCheckboxHandler}>
                    {this.categoryRows}
                </div>
            </div>
        );

    }

}

export default injectIntl(ThirdPartiesCategories);


// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/ThirdPartyRadioGroupOptions/ThirdParties.categories.jsx